import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from 'app/header/header.component';
import { UserAccount } from 'app/services/userAccount.service';
import { ContribService } from '../contrib.service';
import { CurrentUser } from 'app/services/currentUser.service';
import { AppHeaderComponent } from 'app/header/appHeader/appHeader.component';
import { SafeUrl } from '@angular/platform-browser';
import { environment } from 'environments/environment';
@Component({
  selector: 'contrib-finish',
  templateUrl: './finish.component.html',
  styleUrls: ['./finish.component.scss', '../../../+account/account.scss'],
  providers: [HeaderComponent, AppHeaderComponent],

})
export class FinishComponent implements OnInit {
  @Input() isMobile;
  @Input() owner;
  @Input() projectInfo;
  @Input() isguest;
  modalOpen: boolean;
  storyCover: SafeUrl;
  Load: boolean;
  canEdit: boolean;
  change: boolean;
  signUp: boolean;
  isLoading: boolean;
  errors;
  iosUrl = environment.iOSAppLink;
  androidUrl = environment.androidAppLink;
  constructor(private router: Router, private header: HeaderComponent,
    public userAccount: UserAccount, private contribService: ContribService,
    private appHeader: AppHeaderComponent,
    private currentUser: CurrentUser) {

 }

  ngOnInit() {}

  wantSignUp(type: string) {
    this.router.navigate([`account/sign_up/${type}`], {queryParams: { contrib: this.router.url , signUp: true}});
  }

  submit() {
    if (this.isguest) {
      this.wantSignUp('email');
    } else {
      this.redirectToStore();
    }
  }

  redirectToStore() {
    this.router.navigate(['/stories']);
  }

  setIsLoading(ev) {
    this.isLoading = ev;
  }
  setError(ev) {
    this.errors = ev;
  }


}
